import * as React from "react";
import { useAccount } from "wagmi";

type ContextType = {
  selectedWinners: Record<string, any>;
  setSelectedWinners: (state: Record<string, any>) => void;
  matchups: Record<string, any>;
  setMatchups: (state: Record<string, any>) => void;
  votesAreSubmitted: boolean;
  setVotesAreSubmitted: (state: boolean) => void;
  teams: Record<string, any>;
  matches: Array<any>;
  bustedIds: Array<string>;
};

export const Context = React.createContext<ContextType>({
  selectedWinners: {},
  setSelectedWinners: () => {},
  matchups: {},
  setMatchups: () => {},
  votesAreSubmitted: false,
  setVotesAreSubmitted: () => {},
  teams: {},
  matches: [],
  bustedIds: []
});

export const BracketContext: React.FC<
  React.PropsWithChildren<{
    teams: Record<string, any>;
    matches: Array<any>;
    bustedIds: Array<string>;
  }>
> = ({ children, teams, matches, bustedIds }) => {
  const [selectedWinners, setSelectedWinners] = React.useState({});
  const [matchups, setMatchups] = React.useState({});
  const [votesAreSubmitted, setVotesAreSubmitted] = React.useState(false);

  const { address } = useAccount();

  React.useEffect(() => {
    const fetchPicks = async () => {
      if (!address) return;
      const res = await fetch(`/api/brackets/get`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ wallet: address })
      });
      const { data } = await res.json();

      if (data) {
        setSelectedWinners(data?.selectedWinners);
        setMatchups(data?.matchups);
      }
    };
    if (address) {
      fetchPicks();
    }
  }, [address]);

  return (
    <Context.Provider
      value={{
        teams,
        selectedWinners,
        setSelectedWinners,
        matchups,
        setMatchups,
        votesAreSubmitted,
        setVotesAreSubmitted,
        matches,
        bustedIds
      }}>
      {children}
    </Context.Provider>
  );
};

export const useBracketContext = () => React.useContext(Context);
